var abilitiesEsLatam = {
    "1": "Hedor",
    "2": "Llovizna",
    "3": "Impulso",
    "4": "Armadura Batalla",
    "5": "Robustez",
    "6": "Humedad",
    "7": "Flexibilidad",
    "8": "Velo de Arena",
    "9": "Electricidad Estática",
    "10": "Absorbevoltios",
    "11": "Absorbeagua",
    "12": "Despistado",
    "13": "Aclimatación",
    "14": "Ojo Compuesto",
    "15": "Insomnio",
    "16": "Cambio de Color",
    "17": "Inmunidad",
    "18": "Absorbefuego",
    "19": "Polvo Escudo",
    "20": "Ritmo Propio",
    "21": "Ventosas",
    "22": "Intimidación",
    "23": "Sombra Trampa",
    "24": "Piel Tosca",
    "25": "Superguardia",
    "26": "Levitación",
    "27": "Efecto Espora",
    "28": "Sincronía",
    "29": "Cuerpo Puro",
    "30": "Curación Natural",
    "31": "Pararrayos",
    "32": "Dicha",
    "33": "Nado Rápido",
    "34": "Clorofila",
    "35": "Iluminación",
    "36": "Calco",
    "37": "Potencia",
    "38": "Punto Tóxico",
    "39": "Fuerza Mental",
    "40": "Escudo de Magma",
    "41": "Velo de Agua",
    "42": "Imán",
    "43": "Insonorización",
    "44": "Curación Pluvial",
    "45": "Chorro de Arena",
    "46": "Presión",
    "47": "Sebo",
    "48": "Madrugador",
    "49": "Cuerpo de Fuego",
    "50": "Fuga",
    "51": "Perspicacia",
    "52": "Corte Fuerte",
    "53": "Recolección",
    "54": "Pereza",
    "55": "Entusiasmo",
    "56": "Gran Encanto",
    "57": "Más",
    "58": "Menos",
    "59": "Predicción",
    "60": "Viscosidad",
    "61": "Mudar",
    "62": "Agallas",
    "63": "Escama Especial",
    "64": "Toxisecreción",
    "65": "Espesura",
    "66": "Mar de Llamas",
    "67": "Torrente",
    "68": "Enjambre",
    "69": "Cabeza Roca",
    "70": "Sequía",
    "71": "Trampa de Arena",
    "72": "Espíritu Vital",
    "73": "Humo Blanco",
    "74": "Energía Pura",
    "75": "Caparazón",
    "76": "Esclusa de Aire",
    "77": "Tambaleo",
    "78": "Electromotor",
    "79": "Rivalidad",
    "80": "Impasible",
    "81": "Manto Níveo",
    "82": "Gula",
    "83": "Irascible",
    "84": "Liviano",
    "85": "Ignífugo",
    "86": "Simple",
    "87": "Piel Seca",
    "88": "Descarga",
    "89": "Puño Férreo",
    "90": "Antídoto",
    "91": "Adaptable",
    "92": "Encadenado",
    "93": "Hidratación",
    "94": "Poder Solar",
    "95": "Pies Rápidos",
    "96": "Normalidad",
    "97": "Puntería",
    "98": "Muro Mágico",
    "99": "Indefenso",
    "100": "Rezagado",
    "101": "Experto",
    "102": "Defensa Hoja",
    "103": "Torpeza",
    "104": "Rompemoldes",
    "105": "Supersuerte",
    "106": "Secuela",
    "107": "Anticipación",
    "108": "Alerta",
    "109": "Ignorancia",
    "110": "Cromolente",
    "111": "Filtro",
    "112": "Inicio Lento",
    "113": "Intrépido",
    "114": "Colector",
    "115": "Cuerpo de Hielo",
    "116": "Roca Sólida",
    "117": "Nevada",
    "118": "Cosechamiel",
    "119": "Inspección",
    "120": "Audaz",
    "121": "Multitipo",
    "122": "Don Floral",
    "123": "Mal Sueño",
    "124": "Hurto",
    "125": "Potencia Bruta",
    "126": "Respondón",
    "127": "Nerviosismo",
    "128": "Competitivo",
    "129": "Flaquear",
    "130": "Cuerpo Maldito",
    "131": "Alma Sanadora",
    "132": "Compiescolta",
    "133": "Armadura Frágil",
    "134": "Metal Pesado",
    "135": "Metal Liviano",
    "136": "Multiescamas",
    "137": "Ímpetu Tóxico",
    "138": "Ímpetu Ardiente",
    "139": "Cosecha",
    "140": "Telepatía",
    "141": "Temperamental",
    "142": "Funda",
    "143": "Contacto Tóxico",
    "144": "Regeneración",
    "145": "Sacapecho",
    "146": "Ímpetu Arena",
    "147": "Piel Milagrosa",
    "148": "Cálculo Final",
    "149": "Ilusión",
    "150": "Impostor",
    "151": "Allanamiento",
    "152": "Momia",
    "153": "Autoestima",
    "154": "Justiciero",
    "155": "Cobardía",
    "156": "Espejo Mágico",
    "157": "Herbívoro",
    "158": "Timador",
    "159": "Poder Arenoso",
    "160": "Punta Acero",
    "161": "Modo Zen",
    "162": "Tinovictoria",
    "163": "Turbollama",
    "164": "Terravoltaje",
    "165": "Velo Aromático",
    "166": "Velo Florido",
    "167": "Mejillas",
    "168": "Mutatipo",
    "169": "Pelaje Recio",
    "170": "Prestidigitador",
    "171": "Antibalas",
    "172": "Tenacidad",
    "173": "Mandíbula Fuerte",
    "174": "Piel Helada",
    "175": "Velo Dulce",
    "176": "Cambio Táctico",
    "177": "Alas Vendaval",
    "178": "Megalanzador",
    "179": "Manto Frondoso",
    "180": "Simbiosis",
    "181": "Garra Dura",
    "182": "Piel Feérica",
    "183": "Baba",
    "184": "Piel Celeste",
    "185": "Amor Filial",
    "186": "Aura Oscura",
    "187": "Aura Feérica",
    "188": "Rompeaura",
    "189": "Mar del Albor",
    "190": "Tierra del Ocaso",
    "191": "Ráfaga Delta",
    "192": "Firmeza",
    "193": "Huida",
    "194": "Retirada",
    "195": "Hidrorrefuerzo",
    "196": "Ensañamiento",
    "197": "Escudo Limitado",
    "198": "Vigilante",
    "199": "Acuaburbuja",
    "200": "Acero Templado",
    "201": "Ira",
    "202": "Quitanieves",
    "203": "Remoto",
    "204": "Voz Fluida",
    "205": "Socorro",
    "206": "Piel Eléctrica",
    "207": "Cola Surf",
    "208": "Banco",
    "209": "Disfraz",
    "210": "Fuerte Afecto",
    "211": "Agrupamiento",
    "212": "Corrosión",
    "213": "Letargo Perenne",
    "214": "Regia Presencia",
    "215": "Revés",
    "216": "Pareja de Baile",
    "217": "Batería",
    "218": "Mullido",
    "219": "Cuerpo Vívido",
    "220": "Coránima",
    "221": "Rizos Rebeldes",
    "222": "Receptor",
    "223": "Reacción Química",
    "224": "Ultraimpulso",
    "225": "Sistema Alfa",
    "226": "Electrogénesis",
    "227": "Psicogénesis",
    "228": "Nebulogénesis",
    "229": "Herbogénesis",
    "230": "Guardia Metálica",
    "231": "Guardia Espectro",
    "232": "Armadura Prisma",
    "233": "Fuerza Cerebral",
    "234": "Espada Indómita",
    "235": "Escudo Recio",
    "236": "Líbero",
    "237": "Buscabola",
    "238": "Pelusa",
    "239": "Hélice Caudal",
    "240": "Coraza Reflejo",
    "241": "Tragamisil",
    "242": "Acérrimo",
    "243": "Combustible",
    "244": "Punk Rock",
    "245": "Expulsarena",
    "246": "Escama de Hielo",
    "247": "Maduración",
    "248": "Cara de Hielo",
    "249": "Fuente Energía",
    "250": "Mimetismo",
    "251": "Antibarrera",
    "252": "Alma Acerada",
    "253": "Cuerpo Mortal",
    "254": "Alma Errante",
    "255": "Obstinación",
    "256": "Gas Reactivo",
    "257": "Velo Pastel",
    "258": "Mutapetito",
    "259": "Mano Rápida",
    "260": "Puño Invisible",
    "261": "Medicina Extraña",
    "262": "Transistor",
    "263": "Mandíbula Dragón",
    "264": "Relincho Blanco",
    "265": "Relincho Negro",
    "266": "Unidad Ecuestre",
    "267": "Unidad Ecuestre",
    "268": "Aroma Incesante",
    "269": "Disemillar",
    "270": "Termoconversión",
    "271": "Coraza Ira",
    "272": "Sal Purificadora",
    "273": "Pan Comido",
    "274": "Surcavientos",
    "275": "Perro Guardián",
    "276": "Transportarrocas",
    "277": "Energía Eólica",
    "278": "Cambio Heroico",
    "279": "Comandante",
    "280": "Dinamo",
    "281": "Paleosíntesis",
    "282": "Carga Cuark",
    "283": "Cuerpo Áureo",
    "284": "Caldero Debacle",
    "285": "Espada Debacle",
    "286": "Tablilla Debacle",
    "287": "Cuenta Debacle",
    "288": "Latido Oricalco",
    "289": "Motor Hadrónico",
    "290": "Oportunista",
    "291": "Rumia",
    "292": "Cortante",
    "293": "General Supremo",
    "294": "Unísono",
    "295": "Capa Tóxica",
    "296": "Cola Armadura",
    "297": "Geofagia",
    "298": "Poder Fúngico",
    "299": "Hospitalidad",
    "300": "Ojo Mental",
    "301": "Evocarrecuerdos",
    "302": "Evocarrecuerdos",
    "303": "Evocarrecuerdos",
    "304": "Evocarrecuerdos",
    "305": "Cadena Tóxica",
    "306": "Néctar Dulce",
    "307": "Teracambio",
    "308": "Teracaparazón",
    "309": "Teraformación 0"
};
export default abilitiesEsLatam;